import {ConfigService, ErrorsService, Role, ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient, private config: ConfigService, errors: ErrorsService) {
  }

  list(queryParams?: HttpParams): Observable<Role[]> {
    return this.http.get<Role[]>(this.config.apiVerUrl('/app/roles'), {params: queryParams});
  }
}
